import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const CardServer = {
    Card: {
        /**
         * 获取卡片列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/list`,
                { params }
            );
        },
        detail: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-sensitive-details`,
                { params }
            );
        },
        /**
         * 卡片状态更新
         */
        update: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card/card-update-status`,
                params
            );
        },
        /**
         * 刷新卡余额
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/refresh-balance`,
                { params }
            );
        },
    },
    Product: {
        /**
         * 获取卡产品列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-product/list`,
                { params }
            );
        },
        /**
        * 修改状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-product/update-status`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 卡产品状态更新
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-product/refresh`,
                { params }
            );
        },
        /**
         * 卡产品更新
        */
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-product/update`,
                params
            );
        }
    },
    Record: {
        /**
         * 卡片充值提现记录列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-balance-log-list`,
                { params }
            );
        },
        /**
         * 卡片状态列表
        */
        cardStatus: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/udpay-card-status-list`,
                { params }
            );
        },
    },
    Transaction: {
        /**
         * 卡账单（交易记录）
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-transactions`,
                { params }
            );
        },
    },
    Holder: {
        /**
         * 持卡人列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/cardholder-list`,
                { params }
            );
        },
        /**
         * 持卡人信息更新
        */
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card/cardholder-update`,
                params
            );
        },
    },
    Apply: {
        /**
         * 实体卡申请列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/physical-card/apply-list`,
                { params }
            );
        },
        /**
         * 实体卡申请审核
        */
        audit: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/physical-card/audit`,
                params
            );
        },
        /**
         * 实体卡申请列表信息更新(快递信息、审核信息）
        */
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/physical-card/update`,
                params
            );
        }
    },
    Transfer: {
        /**
         * 卡片充值提现记录列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/transfer-list`,
                { params }
            );
        },
    },
}